<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="stockSampleCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.orgStatus === 'Y' ? 'light' : 'warning'">
          {{ row.v_orgStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        // {
        //   field: 'checkbox',
        //   width: 40,
        //   align: 'center',
        //   fixed: 'left',
        //   type: 'checkbox'
        // },
        {
          field: 'defaultImageUrl',
          width: 120,
          title: this.$l('INDEX.table_label_image') || '图片',
          align: 'center',
          fixed: 'left',
          slots: { default: 'defaultImageUrl' }
        },
        {
          title: this.$l('form_label_sample_no') || '样品款号',
          field: 'sampleStyleNo',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_sample_barcode') || '样品条码',
          field: 'sampleBarcode',
          minWidth: 160,
          headerAlign: 'left',
          align: 'left',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_sample_name') || '样品名称',
          field: 'sampleName',
          minWidth: 350,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          // showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_change_qty') || '变动数量',
          field: 'changeNum',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('INDEX.form_label_change_time') || '变动时间',
          field: 'logTime',
          minWidth: 170,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_business_bill_no') || '业务单号',
          field: 'modifyBillNo',
          minWidth: 170,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string'
        },
        {
          title: this.$l('form_label_change_desc') || '变动业务说明',
          field: 'modifyDescription',
          minWidth: 200,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true
        }
      ]
    }
  },
  methods: {}
}
</script>
